import { mediaURLGQLFields } from './mediaURL.fields.js'

export type SignedUrlFields = 'basic' | 'all'

export const signedUrlGQLFields = () => {
  return `
    fields
    mediaId
    mediaUrl
    mediaDownloadUrl
    signedUrl
    urls {
      ${mediaURLGQLFields()}
    }
  `
}
